<template>
  <div>
    <FriedTooltip
      v-if="isGhost"
      :delay="{ show: 300, hide: 100 }"
      :distance="8"
      :placement="TooltipPlacement.Top"
    >
      <CommentExcerpt
        :class="['comment-target-text', { 'is-resolved': isResolved }]"
        :content="targetText"
        is-ghost
      />
      <template #popper>
        <strong>{{ t('cc_tooltip_ghost_comment_header') }}</strong>
        <br />
        {{ t('cc_tooltip_ghost_comment_decription') }}
      </template>
    </FriedTooltip>
    <CommentExcerpt
      v-else-if="isSmallScreenAndDown"
      :class="['comment-target-text', { 'is-resolved': isResolved }]"
      :content="targetText"
    />
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import { Placement as TooltipPlacement } from '@getaccept/fried-tofu';
import { t } from '../../helpers/translation.helper';
import useBreakpoints from '../../composables/breakpoints.composable';
import CommentExcerpt from './CommentExcerpt.vue';

export default defineComponent({
  components: {
    CommentExcerpt,
  },
  props: {
    targetText: {
      type: String,
      required: true,
    },
    isResolved: {
      type: Boolean,
    },
    isGhost: {
      type: Boolean,
    },
  },
  setup() {
    const { isSmallScreenAndDown } = useBreakpoints();

    return {
      TooltipPlacement,
      isSmallScreenAndDown,
      t,
    };
  },
});
</script>
<style lang="scss" scoped>
.comment-target-text {
  margin-bottom: var(--spacing-100);
}
</style>
